// extracted by mini-css-extract-plugin
module.exports = {"tagContainer":"SupplierFormFields_tagContainer__2EIUr","tag":"SupplierFormFields_tag__1B2lO","buttonContainer":"SupplierFormFields_buttonContainer__2UlX2"};